interface SurchargeRow {
  payableAtProperty?: boolean
}

interface DaySurcharge {
  extraGuestSurcharge?: number
  extraGuestSurchargePayableAtProperty?: number
}

interface RoomRateSurcharges {
  extraGuestSurcharges?: Array<SurchargeRow | undefined>
}

// Hotel-collected part of the svc-calendar day's surcharge; the flag fallback covers cache rows that predate the field.
// Never feed public-offer's value in here: its legacy path reports 0 for hotel-only rates.
export function getExtraGuestSurchargePayableAtProperty(
  day: DaySurcharge | undefined,
  roomRate: RoomRateSurcharges | undefined,
): number {
  if (day?.extraGuestSurchargePayableAtProperty != null) {
    return day.extraGuestSurchargePayableAtProperty
  }

  const rows = roomRate?.extraGuestSurcharges
  const anyPayableAtProperty = !!rows?.length && rows.some(row => row?.payableAtProperty)
  return anyPayableAtProperty ? (day?.extraGuestSurcharge ?? 0) : 0
}
